import React from "react";
import { useNavigate } from "react-router-dom";
import "./index.scss";

const Loading = () => {
  const navigate = useNavigate();

  return (
    <div className="centered">
      <div className="loader"></div>
    </div>
  );
};

export default Loading;
